import React, { Component } from 'react';
import '../../App.css';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';
import AppIcon from '../../components/AppIcon';
import { loggedIn } from '../../modules/user';
import { toggleAppSidebar } from '../../modules/app';

import { appUtil, featureToggleUtil } from '../../utils';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import BetaReaderLogoAndName from '../../components/svg/BetaReaderLogoAndName';

const Left = styled.div`
  text-align: left;
`;

const MenuButton = styled.button.attrs({type: 'button'})`
  background: none;
  border: 0;
  color: inherit;
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:focus-visible { outline: 2px solid var(--br-focus); }
`;

export class AppMenu extends Component {
  unsubScribeHistoryListener;

  constructor(props) {
    super(props);
    this.state = {};
    this.unsubScribeHistoryListener = props.history.listen(() => {
      // close submenu if changing location in small screen mode
      if (appUtil.isSmallScreen()) {
        this.setState({
          showSubMenu: false,
        });
      }
    });
  }

  componentWillUnmount() {
    this.unsubScribeHistoryListener();
  }

  handlePageClick = name => {
    // if we are on a small screen, close side bar after menu selection
    if (window && window.innerWidth && window.innerWidth < 768) {
      this.props.toggleAppSidebar(false);
    }
    this.props.changePage(`/${name}`);
  };

  openInNewWindow = url => {
    window.open(url, 'betareader.io_reader');
  };

  isOnPath = name => {
    const { location } = this.props;
    return location && location.pathname.startsWith(name);
  };

  showSubMenu = menu => {
    this.setState({
      showSubMenu: menu,
    });
  };

  shouldShowSubMenu = menu => {
    const { showSubMenu } = this.state;
    const isActive = showSubMenu === menu;
    if (!isActive) {
      return this.isOnPath(`/${menu}`);
    }
    return isActive;
  };

  render() {
    const { userProfile, t, critiqueGroupsEnabled } = this.props;
    const item = (key, name, icon, label, active = this.isOnPath(`/${name}`)) => (
      <MenuButton
        key={key}
        className={`item${active ? ' active' : ''}`}
        aria-current={active ? 'page' : undefined}
        onClick={() => this.handlePageClick(name)}
      >
        <Left><AppIcon name={icon} /> {label}</Left>
      </MenuButton>
    );
    return [
      <div className="item" key="about"><BetaReaderLogoAndName /></div>,
      userProfile && (
        item('mymanuscripts', 'mymanuscripts', 'book', t('MyManuscripts'))
      ),
      userProfile && (
        item('readingList', 'readinglist', 'bookmark', t('ReadingList'))
      ),
      item('discover', 'discover', 'search', t('Discover')),
      item(
        'sample-chapters', 'sample-chapters/discover', 'book',
        t('SampleChaptersBrowse', 'Sample chapters'),
        this.isOnPath('/sample-chapters/discover') ||
          this.isOnPath('/sample-chapters/read')
      ),
      item('feed', 'feed', 'feed', t('Feed')),
      userProfile && critiqueGroupsEnabled && (
        item('critique-groups', 'critique-groups', 'users',
          t('CritiqueGroups', 'Critique groups'))
      ),
      userProfile && (
        item('readers', 'readers', 'book', t('ReaderList'))
      ),
      userProfile && (
        item('inbox', 'inbox', 'comments outline', t('Chat'))
      ),
    ];
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
  alerts: state.app.alerts,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loggedIn,
      toggleAppSidebar,
      changePage: newPage => push(newPage),
    },
    dispatch
  );

const ConnectedAppMenu = withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(AppMenu))
);

// Bridge the critique_groups flag (a hook) into the connected class so the nav
// item stays dark by default. Two-tier like the rest of the app: the global
// flag OR the user's beta grant — the API applies the same OR, so gating on the
// global flag alone would hide the nav from beta users the API would serve.
const AppMenuWithFlags = props => {
  const { flags, isLoading: flagsLoading } = useFeatureFlags();
  const userProfile = useSelector(state => state.user.userProfile);
  const critiqueGroupsEnabled =
    (!flagsLoading && flags?.critique_groups === true) ||
    featureToggleUtil.hasFeatureAccess(userProfile, 'critique_groups');
  return (
    <ConnectedAppMenu {...props} critiqueGroupsEnabled={critiqueGroupsEnabled} />
  );
};

export default AppMenuWithFlags;
